import Swal from 'sweetalert2';

// Custom Swal configurations with compact, elegant styling
export const SwalConfig = {
  // Success Alert - Compact & Elegant
  success: (title, message, timer = 2000) => {
    return Swal.fire({
      icon: 'success',
      title: title,
      text: message,
      timer,
      timerProgressBar: true,
      showConfirmButton: false,
      width: '350px',
      padding: '1rem',
      customClass: {
        popup: 'swal-compact',
        title: 'swal-title-small',
        content: 'swal-content-small'
      },
      backdrop: 'rgba(0,0,0,0.3)'
    });
  },

  // Error Alert - Compact & Elegant
  error: (title, message) => {
    return Swal.fire({
      icon: 'error',
      title: title,
      text: message,
      confirmButtonText: 'OK',
      width: '350px',
      padding: '1rem',
      customClass: {
        popup: 'swal-compact',
        title: 'swal-title-small',
        content: 'swal-content-small',
        confirmButton: 'swal-button-small'
      },
      backdrop: 'rgba(0,0,0,0.3)'
    });
  },

  // Warning Alert - Compact & Elegant
  warning: (title, message, confirmText = 'OK') => {
    return Swal.fire({
      icon: 'warning',
      title: title,
      text: message,
      confirmButtonText: confirmText,
      width: '350px',
      padding: '1rem',
      customClass: {
        popup: 'swal-compact',
        title: 'swal-title-small',
        content: 'swal-content-small',
        confirmButton: 'swal-button-small'
      },
      backdrop: 'rgba(0,0,0,0.3)'
    });
  },

  // Confirmation Alert - Compact & Elegant
  confirm: (title, message, confirmText = 'Ya', cancelText = 'Batal') => {
    return Swal.fire({
      icon: 'question',
      title: title,
      text: message,
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      confirmButtonColor: '#3b82f6',
      cancelButtonColor: '#6b7280',
      width: '380px',
      padding: '1rem',
      customClass: {
        popup: 'swal-compact',
        title: 'swal-title-small',
        content: 'swal-content-small'
      },
      backdrop: 'rgba(0,0,0,0.3)'
    });
  },

  // Delete Confirmation - Compact & Elegant
  deleteConfirm: (itemName = 'data ini') => {
    return Swal.fire({
      icon: 'question',
      title: 'Hapus Data?',
      text: `Yakin ingin menghapus ${itemName}? Tindakan ini tidak dapat dibatalkan.`,
      showCancelButton: true,
      confirmButtonText: 'Ya, Hapus!',
      cancelButtonText: 'Batal',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      width: '380px',
      padding: '1rem',
      customClass: {
        popup: 'swal-compact',
        title: 'swal-title-small',
        content: 'swal-content-small'
      },
      backdrop: 'rgba(0,0,0,0.3)'
    });
  },

  // Loading Alert - Compact & Elegant
  loading: (title = 'Memproses...', message = 'Mohon tunggu sebentar') => {
    return Swal.fire({
      title: title,
      text: message,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
      width: '300px',
      padding: '1rem',
      customClass: {
        popup: 'swal-compact',
        title: 'swal-title-small',
        content: 'swal-content-small'
      },
      backdrop: 'rgba(0,0,0,0.3)'
    });
  },

  // Info Alert - Compact & Elegant
  info: (title, message, confirmText = 'OK') => {
    return Swal.fire({
      icon: 'info',
      title: title,
      text: message,
      confirmButtonText: confirmText,
      width: '350px',
      padding: '1rem',
      customClass: {
        popup: 'swal-compact',
        title: 'swal-title-small',
        content: 'swal-content-small',
        confirmButton: 'swal-button-small'
      },
      backdrop: 'rgba(0,0,0,0.3)'
    });
  },

  // Validation Warning - Compact & Elegant
  validationWarning: (missingFields = []) => {
    const fieldList = missingFields.map(field => `• ${field}`).join('\n');
    return Swal.fire({
      icon: 'warning',
      title: 'Data Tidak Lengkap',
      text: `Mohon lengkapi data berikut:\n${fieldList}`,
      confirmButtonText: 'OK',
      width: '350px',
      padding: '1rem',
      customClass: {
        popup: 'swal-compact',
        title: 'swal-title-small',
        content: 'swal-content-small',
        confirmButton: 'swal-button-small'
      },
      backdrop: 'rgba(0,0,0,0.3)'
    });
  }
};

export default SwalConfig;
